import { useEffect, useMemo } from 'react';

import { loadTranslations } from '../domains/translations/actions';
import { useTranslationDataForFeature } from '../domains/translations/selectors';
import { useCurrentLocale } from '../hooks/selectors';
import type { StringWrapperCtor } from '../state/types';

export type UseTranslations = <T>(Strings: StringWrapperCtor<T>) => T;
export const useTranslations: UseTranslations = (from) => {
  const rawTranslations = useTranslationDataForFeature(from.feature);
  const locale = useCurrentLocale();

  useEffect(() => {
    void loadTranslations({
      locale,
      feature: from.feature,
    });
  }, [from, locale]);

  return useMemo(() => new from(locale, rawTranslations), [from, locale, rawTranslations]);
};
